<template>
  <div
    v-for="(meterpointTariffs, index) in sortedMeterPointsTariffs"
    :key="index"
    class="meterpoint-tariff-container"
  >
    <SoWidget
      v-if="meterpointTariffs.meterpoint.supplyStatus !== 'NotSupplied'"
      data-testid="meterpoint-tariff-widget"
    >
      <MeterpointTariffs
        :meterpoint="meterpointTariffs.meterpoint"
        :meterpoint-tariffs="meterpointTariffs"
        :current-tariff="meterpointTariffs.currentTariff"
      />
    </SoWidget>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useRenewalsStore } from "@/stores/renewals"
  import MeterpointTariffs from "../components/MeterpointTariffs.vue"
  import SoWidget from "@/components/SoWidget.vue"

  export default defineComponent({
    components: {
      MeterpointTariffs,
      SoWidget,
    },
    data() {
      return {
        renewals: useRenewalsStore(),
      }
    },
    computed: {
      sortedMeterPointsTariffs() {
        const tempObj = { ...this.renewals.meterpointTariffs }

        return [...Object.values(tempObj)].sort((a, b) =>
          a.meterpoint.meterpointType < b.meterpoint.meterpointType ? -1 : 1,
        )
      },
    },
  })
</script>

<style scoped>
  .meterpoint-tariff-container:not(:last-of-type) {
    margin-bottom: 1rem;
  }
</style>
